import Car from '../../Assets/Images/CarBP.png'
import Bike from '../../Assets/Images/bikeBP.png'
import Health from '../../Assets/Images/healthBP.png'
import HealthHover from '../../Assets/Images/Health-Insurance-White.png'
import Life from '../../Assets/Images/lifeBP.png'
import CarHover from '../../Assets/Images/CarHover.png';
import BikeHover from '../../Assets/Images/bikeHover.png';
import LifeHover from '../../Assets/Images/LifeHover.png';

const ProductData = {
    data: [

        {
            id: 1,
            product_name: "Car",
            image: Car,
            link: `${process.env.PUBLIC_URL}/motor-insurance/car-insurnace`
            
            
        },
        {
            id: 2,
            product_name: "Bike",
            image: Bike,
            // link: `${process.env.PUBLIC_URL}/motor-insurance`
            link: `#`

        },
        {
            id: 3,
            product_name: "Health",
            image: Health,
            // link: `${process.env.PUBLIC_URL}/health-insurance`
            link: `#`
        },
        {
            id: 4,
            product_name: "Term Life",
            image: Life,
            // link: `${process.env.PUBLIC_URL}/life-insurance`
            link: `#`
        },

    ]
};

export default ProductData;
